import React, { useState, useRef, forwardRef, useImperativeHandle, useEffect } from "react";
import {Spin } from 'antd';
import { LoadingOutlined, } from '@ant-design/icons';

import './index.scss';

const HeaderSearch = forwardRef(({ 
    options = {}, // input参数
    conditionList = [], // 查询条件列表
    onSearch = () => {}, // 查询回调
    loading = false, // 加载状态
    initialValues = {}, // 初始值，用于回显
}, ref) =>
{
    const [params, setParams] = useState(initialValues);
    const headSearchRef = useRef(null);
    
    // 监听外部初始值变化，更新内部状态
    useEffect(() => {
        setParams(initialValues);
    }, [initialValues]);

    // 点击查询条件
    const handleChangeParams = (value, props) =>
    {   
        setParams({
            ...params,
            [props]: [value],
        });

        if (onSearch)
        {
            onSearch({
                ...params,
                [props]: [value],
            });
        }
    }

    const clearSearch = () =>
    {
        setParams({});
        if (onSearch)
        {
            onSearch();
        }
    }
    // 获取检索元素的高度
    useImperativeHandle(ref, () => ({
        dom: headSearchRef && headSearchRef.current ? headSearchRef.current.offsetHeight : 0
    }));

    return (
        <div ref={headSearchRef} className="enterprise-header-search-wrap"  component-data="partTimeSearch">
            <Spin spinning={loading} indicator={<LoadingOutlined />}>
                <div className="header-search">
                    <div className="header-search-condition">
                        {
                            conditionList.map((item, index) => {
                                return (
                                    <div className="header-search-condition-item" key={index}>
                                        <label style={{ width: options.labelWidth || '100px', }}>{item.label}：</label>
                                        <ul style={{ width: `calc(100% - ${options.labelWidth || "100px"})` }}>
                                            {/* <li 
                                                className={params[item.props] && params[item.props] !== '' ? "" : "condition-item-value-active"}
                                                onClick={() => { 
                                                    handleChangeParams(undefined, item.props)    
                                                }} 
                                            >不限</li> */}
                                            {
                                                item.options.map((vitem, vindex) => {
                                                    return (
                                                        <li 
                                                            key={vindex} 
                                                            onClick={() => { 
                                                                handleChangeParams(vitem[item.valueProps], item.props)    
                                                            }} 
                                                            className={params[item.props] && params[item.props][0] == vitem[item.valueProps] ? "header-search-condition-item-value condition-item-value-active" : "header-search-condition-item-value"}
                                                        >{vitem.name}</li>
                                                    )
                                                })
                                            }
                                        </ul>
                                    </div>
                                )
                            })
                        }
                        
                        <div className="header-search-btn-wrap">
                            <div className="header-search-btn-clear" onClick={() => clearSearch()}>清空筛选条件</div>
                        </div>
                    </div>
                </div>
            </Spin>
        </div>
    );
})

export default HeaderSearch;